/**
 * @example
 * import { isString } from '@cwp/utils'
 *
 * isString('foo') // true
 * isString(['foo']) // false
 */
export default function isString (item) {
  return typeof item === 'string'
}
